import { Plot } from '../../core/plot';
import { deepAssign } from '../../utils';

/**
 * æçº¿å¾é»è®¤éç½®é¡¹
 */
export const DEFAULT_OPTIONS = deepAssign({}, Plot.getDefaultOptions(), {
  tooltip: {
    shared: true,
    showMarkers: true,
    showCrosshairs: true,
    crosshairs: {
      type: 'x',
    },
  },
  legend: {
    position: 'top-left',
    radio: {},
  },
  isStack: false,
});
